// extracted by mini-css-extract-plugin
module.exports = {"popupCloseOverlay":"Popup_popupCloseOverlay__3uqMs","container":"Popup_container__2sKLz","popup":"Popup_popup__weO_V"};